<template>
    <div class="neirong">
        <a-row style="height:100%">
            <a-col :span="4" style="height:100%">
                <DetailLeft :info="info" />
            </a-col>
            <a-col :span="16" style="padding:0 50px">
                <DetailCenter :info="info" />
            </a-col>
            <a-col :span="4">
                <DetailRight :gaojing="gaojing" />
            </a-col>
        </a-row>
    </div>
</template>

<script>
import http from "@/api/http";
import { useStore } from "vuex";
import DetailLeft from "./dianyuan/DetailLeft.vue";
import DetailRight from "./dianyuan/DetailRight.vue";
import DetailCenter from "./dianyuan/DetailCenter.vue";
import { defineComponent, ref, onMounted } from "vue";
export default defineComponent({
    name: 'JiZhan',
    components: {
        DetailLeft,
        DetailRight,
        DetailCenter
    },
    props: {

    },
    setup() {

        let info = ref({})
        let gaojing = ref({})
        const store = useStore()
        let stationid = store.getters['User/stationid']
        const getData = () => {
            http.get("/base_station_warning/" + stationid + "/statistics").then((res) => {

                gaojing.value = res.data

            });
            http.get("/base_station/" + stationid + "/power").then((res) => {

                info.value = res.data

            });
        };

        onMounted(() => {
            //组件挂载时的生命周期执行的方法
            getData();
        });

        return {
            info, gaojing
        };
    },
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.neirong {

    height: 100%;
    background: url("@/assets/bg2.jpg");
    background-size: 100% 100%;
    width: 100%;
}
</style>
